import {Form, Col, Button, Row} from '@deere/ux.uxframe-react';
import React from 'react'
import { CM_RESPONSE_STATUS,SCBM_STATES_CAMPAIGN, SCBM_USER_TYPE } from '../../utils/surveyLiterals'
import { useTranslation } from "react-i18next";
import { useUserInfo } from '../../providers/userProvider'

function disableSubmitButtons(tpsResponse, campaign, userInfo, isSubmit){
    const deereUser = userInfo && userInfo.userType === SCBM_USER_TYPE.SALARY;
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED  || deereUser;
}

function disableDeleteButton(tpsResponse, campaign, userInfo, isSubmit,adminRole){
    const deereUser = userInfo && userInfo.userType === SCBM_USER_TYPE.SALARY;
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED || (tpsResponse.status === CM_RESPONSE_STATUS.SUBMITTED && isSubmit) || (!userInfo.roles.includes(adminRole) && deereUser);
}

export default function ActionsTpsReviewSurvey({setShowAgreement,tpsResponse,setShowValidation,campaign,backToEdit,survey}){
    const userInfo = useUserInfo();
    const { t } = useTranslation();

    const submitSurveyResponses = () =>{
        setShowAgreement(true);
    }

    const showValidation = () =>{
        setShowValidation(true)
    }

    return (<>
            <Row className="card position-sticky fixed-bottom d-print-none">
                <Row className="card position-sticky fixed-bottom">
                    <Col md="24" className="card-body p-3 text-right">
                        <Form.Group as={Col} className="align-right">  
                            <Button variant="primary" className="float-right" onClick={submitSurveyResponses} disabled={!tpsResponse || disableSubmitButtons(tpsResponse,campaign, userInfo, true)}>{t('btn_review_submit')}</Button>
                            <Button variant="secondary" className="float-right mr-2" onClick={e =>backToEdit()} >{t('btn_review_back_to_edit')}</Button> 
                            <Button variant="secondary" className="float-right mr-2" onClick={showValidation} disabled={!tpsResponse || disableDeleteButton(tpsResponse,campaign, userInfo, false, survey.adminRole)}>{t('btn_review_delete')}</Button>
                        </Form.Group>
                    </Col>
                </Row>
            </Row>             
            </>)
}   